<template>
  <div class="chart-container">
    <div class="chart-controls">
      <button
        class="year-btn"
        :class="{ active: selectedYear === getLastYearRange[0].substring(0, 4) }"
        @click="selectYear(getLastYearRange)"
      >
        {{ this.getLastYearRange[0].substring(0, 4) }}
      </button>
      <button
        class="year-btn"
        :class="{ active: selectedYear === getThisYearRange[0].substring(0, 4) }"
        @click="selectYear(getThisYearRange)"
      >
        {{ this.getThisYearRange[0].substring(0, 4) }}
      </button>
      <button
        class="year-btn"
        :class="{ active: selectedYear === getNextYearRange[0].substring(0, 4) }"
        @click="selectYear(getNextYearRange)"
      >
        {{ this.getNextYearRange[0].substring(0, 4) }}
      </button>
    </div>
    <div class="chart-wrapper">
      <finance-line-chart
        :chart-data="chartData"
        style="height: 400px; position: relative;"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    "finance-line-chart": () =>
      import("@/components/common/charts/FinanceLineChart.vue"),
  },
  data() {
    return {
      chartData: {},
      selectedYear: null
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    selectYear(range) {
      this.selectedYear = range[0].substring(0, 4);
      this.fetchData(range);
    },
    fetchData(range) {
      const data = {
        query: `
          query  {
            RevenueStats(
              from: "${range[0]}",
              to: "${range[1]}"
            )
          }
        `
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.chartData = JSON.parse(res.RevenueStats)
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    }
  },
  computed: {
    ...mapGetters([
      "getThisYearRange",
      "getLastYearRange",
      "getNextYearRange",
      "getUserSystem"
    ])
  },
  watch: {
    getUserSystem: function() {
      this.selectedYear = this.getThisYearRange[0].substring(0, 4);
      this.fetchData(this.getThisYearRange);
    }
  },
  mounted() {
    this.selectedYear = this.getThisYearRange[0].substring(0, 4);
    this.fetchData(this.getThisYearRange);
  }
};
</script>

<style scoped>
.chart-container {
  padding: 0;
}

.chart-controls {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  background: white;
  padding: 4px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: fit-content;
}

.year-btn {
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: #4a5568;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.year-btn:hover {
  background-color: #edf2f7;
}

.year-btn.active {
  background-color: #5469d4;
  color: white;
}

.chart-wrapper {
  margin-top: 16px;
}
</style>
